.chip {
  display: inline-flex;
  align-items: center;
  min-width: 2.5rem;
  max-width: 12rem;
  min-height: 1.5rem;
  padding: 0 var(--space-2);
  overflow: hidden;
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
